import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CourseCategory } from '../dataTypes';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CourseCategoryService {
  constructor(private http: HttpClient) {}
  /**
   * Returns a list of all coursecategories as CourseCategory[]
   * @returns
   */
  getCourseCategories(): Observable<CourseCategory[]> {
    return this.http.get<CourseCategory[]>('/api/CourseCategories');
  }

   
  /**
   * Updates an existing coursecategory or creates a new one if the id is 0
   * @param courseCategory 
   * @returns 
   */
 upsertCourseCategory(courseCategory: CourseCategory): Observable<CourseCategory> {
  if (courseCategory.id === 0) {
    return this.http.post<CourseCategory>('/api/CourseCategories', courseCategory);
  } else {
    return this.http.put<CourseCategory>('/api/CourseCategories', courseCategory);
  }
}

  /**
   * Deletes a coursecategory database value with the use of a CourseCategory object
   * @param delCourseCategory
   * @returns
   */
  deleteCourseCategory(delCourseCategory: CourseCategory): Observable<CourseCategory> {
    return this.http.delete<CourseCategory>('/api/CourseCategories', {
      body: delCourseCategory,
    });
  }

  
}
